import { IStatusField } from './StatusField.interface'

// export const STATUS_FIELD = {
//   NOT_PLANNED: 'Not Planned',
//   PLANNED: 'Planned',
//   SUBMITTED: 'Submitted',
//   REJECTED: 'Rejected',
//   APPROVED: 'Approved',
// }

export const STATUS_FIELD_SUBMIT_REJECT_APPROVE = {
  NOT_PLANNED: 'Not Planned',
  PLANNED: 'Planned',
  SUBMITTED: 'Submitted',
  REJECTED: 'Rejected',
  APPROVED: 'Approved',
}

export const STATUS_FIELD_START_FINISH = {
  NOT_PLANNED: 'Not Planned',
  PLANNED: 'Planned Start',
  SUBMITTED: 'Submitted',
  REJECTED: 'Rejected',
  APPROVED: 'Approved',
}

export const STATUS_FIELD_PASS_FAIL = {
  NOT_PLANNED: 'Not Planned',
  PLANNED: 'Planned Start',
  SUBMITTED: 'Submitted',
  REJECTED: 'Rejected',
  APPROVED: 'Approved',
}

export const STATUS_FIELD_COLOR = {
  ['Not Planned']: 'rgba(0, 0, 0, 0.65)',
  ['Planned']: 'rgba(0, 0, 0, 0.65)',
  ['Submitted']: 'rgba(0, 0, 0, 0.65)',
  ['Rejected']: '#ff5a43',
  ['Fail']: '#ff5a43',
  ['Approved']: '#28a745',
  ['Pass']: '#28a745',
}

export const STATUS_FIELD_DATA: IStatusField = {
  plan_submit_approve_reject_type: STATUS_FIELD_SUBMIT_REJECT_APPROVE,
  plan_inprogress_done_type: STATUS_FIELD_START_FINISH,
  plan_pass_fail_type: STATUS_FIELD_PASS_FAIL,
  plan_percentage_type: STATUS_FIELD_PASS_FAIL,
}

export const STATUS_LABEL_COLOR = {
  approved: 'text-success',
  started: 'text-success',
  done: 'text-success',
  pass: 'text-success',
  rejected: 'text-danger',
  ['fail']: 'text-danger',
  submitted: '',
  ['planned_start']: '',
  ['not_planned']: 'text-danger',
  finished: 'text-primary',
}

export const COMPLETE_BACKGROUND_COLOR = {
  approved: 'text-success',
  started: 'text-success',
  done: 'text-success',
  pass: 'text-success',
  rejected: 'text-danger',
  ['fail']: 'text-danger',
  submitted: '',
  ['planned_start']: '',
  ['not_planned']: 'text-danger',
}
